import type { SVGProps } from "react";
export interface Numer7CircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Numer7CircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Numer7CircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M10.376 16c0-2.605 1.055-4.912 2.13-6.875H9.75a1.125 1.125 0 0 1 0-2.25H14c1.062 0 1.714 1.147 1.193 2.058-1.318 2.304-2.567 4.551-2.567 7.066a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
